import _extends from "@babel/runtime/helpers/extends";
import { Box, ClickableCard, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import { mergeWdsBoxColorProps, resolveWdsBoxColorProps, wdsThemeColors } from '@wix/rules-panel-ui';
import React, { useState } from 'react';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { getRuleElementPropsFromCapabilities } from '../../../utils/get-fixer-design-props';
export const FailedElementItem = _ref => {
  let {
    displayName,
    onViewClick,
    dataHook
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const softIssueListSurfaces = capabilities.wizardPresentation.softIssueListSurfaces;
  const {
    hoveredBorderColor,
    notHoveredBorderColor
  } = getRuleElementPropsFromCapabilities(capabilities);
  const [isHovered, setIsHovered] = useState(false);
  const borderColor = isHovered ? hoveredBorderColor : notHoveredBorderColor;
  const backgroundColor = softIssueListSurfaces ? undefined : isHovered ? 'B50' : 'white';
  const surfaceProps = mergeWdsBoxColorProps(resolveWdsBoxColorProps(borderColor, 'borderColor'), ...(softIssueListSurfaces ? [resolveWdsBoxColorProps(wdsThemeColors.surfaceNeutral)] : []));
  return /*#__PURE__*/React.createElement(ClickableCard, {
    dataHook: dataHook,
    disabled: !onViewClick,
    hasPadding: false,
    skin: "outline",
    onClick: () => onViewClick == null ? void 0 : onViewClick(),
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false)
  }, /*#__PURE__*/React.createElement(Box, _extends({
    align: "space-between",
    backgroundColor: backgroundColor,
    border: "1px solid",
    borderRadius: "6px",
    cursor: onViewClick ? 'pointer' : 'default',
    direction: "horizontal",
    minHeight: "18px",
    padding: "SP2 SP3",
    verticalAlign: "middle",
    width: "100%"
  }, surfaceProps), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, displayName), isHovered && onViewClick && /*#__PURE__*/React.createElement(Text, {
    light: softIssueListSurfaces,
    size: "tiny",
    underline: "always"
  }, t('accessibility-wizard.rules-list.page-auto-dom-order.failed-element-item.view'))));
};
//# sourceMappingURL=failed-element-item.js.map